import React, { useState, useEffect } from "react";
import Board from "./components/Board";
import { loadState, saveState } from "./utils/localStorage";
import { DndContext } from "@dnd-kit/core";

export default function App() {
    const [columns, setColumns] = useState(() =>
            loadState("kanbanColumns") || [
                { id: "col1", title: "To Do", cards: [] },
                { id: "col2", title: "In Progress", cards: [] },
                { id: "col3", title: "Done", cards: [] },
            ]
    );

    useEffect(() => saveState("kanbanColumns", columns), [columns]);

    const handleDragEnd = (event) => {
        const { active, over } = event;
        if (!over) return;

        const activeCardId = active.id;
        const overColumnId = over.id;

        setColumns((prev) => {
            const newCols = prev.map((c) => ({
                ...c,
                cards: [...c.cards],
            }));

            let draggedCard = null;
            let fromColIndex = null;

            newCols.forEach((col, i) => {
                const idx = col.cards.findIndex((card) => card.id === activeCardId);
                if (idx > -1) {
                    draggedCard = col.cards[idx];
                    col.cards.splice(idx, 1);
                    fromColIndex = i;
                }
            });

            const toColIndex = newCols.findIndex((c) => c.id === overColumnId);

            if (draggedCard && toColIndex > -1) {
                newCols[toColIndex].cards.push(draggedCard);
            }

            return newCols;
        });
    };

    return (
        <div className="name">
        <h1>Welcome to Drag-Drop Organizer</h1>
        <p>Drag-And-Drop Organizer is not just a task planner, but a very good assistant in make plans. You can create cards and then drag them during the progress if you haven't finished them, or drag them to completed tasks.</p>
        <h2>Plan for day</h2>
        <DndContext onDragEnd={handleDragEnd}>
            <Board columns={columns} setColumns={setColumns} />
        </DndContext>
         <h3>Plan for week</h3>
            <DndContext onDragEnd={handleDragEnd}>
                <Board columns={columns} setColumns={setColumns} />
            </DndContext>
         <h4>Plan for month</h4>
         <DndContext onDragEnd={handleDragEnd}>
             <Board columns={columns} setColumns={setColumns} />
         </DndContext>
        </div>
    );
}
